<app-form-editorrights
    [result]="selectedResult"
    [groupList]="groupList"
    [userList]="userList"
    [customEditorList]="customEditorList"
    (onValidate)="validate($event)"
    (onCancel)="cancel($event)"
    (onDelete)="delete($event)"
>
</app-form-editorrights>

